module.exports = __webpack_public_path__ + "img/744.2c96f3f1.jpg";